import {FaHeadphonesAlt} from 'react-icons/fa';
import {BsDropletFill} from 'react-icons/bs';
import {AiTwotoneMessage} from 'react-icons/ai';
export const contactData =[
    {
        icon:<FaHeadphonesAlt/>,
        title:"Call Us",
        desc:"Office Phone: +52 222 3211"
    },
    {
        icon:<BsDropletFill />,
        title:"Where to find us",
        desc:"287 Natalie Glens Apt. 214 San Francisco, CA"
    },
    {
        icon:<AiTwotoneMessage />,
        title:"Write to us",
        desc:"support@hostdesign.com"
    }
]